import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { Observable, from, catchError, throwError, switchMap } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SupersetService {

  id_char = "750f10f5-bb70-43be-84ce-4ae50b2c6c97"

  
  api = 'indicadores.tech-test.com.ar';

  

  private apiUrl = 'https://'+this.api+'/api/v1/security';
  private domain = 'https://'+ this.api

  constructor(private http: HttpClient) { }

   fetchAccessToken(): Observable<any> {
    const body = {
      "username": "guest",
      "password": "guest",
      "provider": "db",
      "refresh": true
    };

    return this.http.post<any>(`${this.apiUrl}/login`, body);
  }

  /**
   * 
   * @returns { guest token } using @param { accessToken }
   */
  private fetchGuestToken(accessToken: any): Observable<any> {
    const body = {
        "resources": [
            {
                "type": "dashboard",
                "id": this.id_char ,
            }
        ],
        "rls": [],
        "user": {
            "username": "guest",
            "first_name": "guest",
            "last_name": "guest",
        }
    };

    const acc = accessToken["access_token"]; // accessToken is an object with access_token and refresh_token

    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${acc}`,
    };

    const apiUrl = this.apiUrl; // Reemplaza con tu URL

    // Asegúrate de que la URL termine con una barra diagonal (/)
    const url = `${apiUrl}/guest_token/`;

    return from(fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body),
    })
    .then(response => response.json())
    .then(data => {
        // Puedes realizar acciones con la respuesta (data) aquí si es necesario
        return data;
    })
    .catch(error => {
        console.error('Error al obtener el guest_token:', error);
        throw error; // Puedes manejar el error según tus necesidades
    }));
}


  getGuestToken(): Observable<any> {
    return this.fetchAccessToken().pipe(
      catchError((error) => {
        console.error(error);
        return throwError(error);
      }),
      switchMap((accessToken: any) => this.fetchGuestToken(accessToken))
    );
  }
  /**
   * 
   * @returns { dashboard }
   */
  embedDashboard(): Observable<void> {
    return new Observable((observer) => {
      this.getGuestToken().subscribe(
        (token) => {
          embedDashboard({
            id: this.id_char, // Replace with your dashboard ID
            supersetDomain: this.domain,
            mountPoint: document.getElementById('dashboard'),
            fetchGuestToken: () => token["token"],
            dashboardUiConfig: {
              hideTitle: true,
              hideChartControls: true,
              hideTab: true,
            },
          });
          observer.next();
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }
}
